import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { HomepagePathsSchema, type HomepagePaths } from "@/lib/validation";
import type { UseMetricOptions } from "./useTraffic";

export function useHomepagePaths(
  range: TimeRange,
  options: UseMetricOptions = {},
) {
  return useQuery<HomepagePaths>({
    queryKey: qk.metrics.homepagePaths(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/homepage-paths?${toSearchParams(range).toString()}`,
        { signal },
      );
      return HomepagePathsSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
